module.exports = __webpack_public_path__ + "static/media/golfer-7-b.73c59770.png";